/* unplugin-vue-components disabled */import { render } from "./onboarding.vue?vue&type=template&id=12f51a42&scoped=true"
import script from "./onboarding.vue?vue&type=script&lang=js"
export * from "./onboarding.vue?vue&type=script&lang=js"

import "./onboarding.vue?vue&type=style&index=0&id=12f51a42&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f51a42"],['__file',"src/components/ai-chat/ai-assistant/onboarding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12f51a42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12f51a42', __exports__)) {
    api.reload('12f51a42', __exports__)
  }
  
  module.hot.accept("./onboarding.vue?vue&type=template&id=12f51a42&scoped=true", () => {
    api.rerender('12f51a42', render)
  })

}


export default __exports__